<template>
	<div class="all_main">
		<myheader headTitle="账户与安全"></myheader>
		<div class="all_height_line24 backgroundC_white display_flex bwhite_ative" @click="toChangePassword()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">重设密码</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<div class="all_height_line24 backgroundC_white display_flex bwhite_ative" @click="toChangeMobile()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">更换手机号码</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			//修改密码
			toChangePassword() {
				this.$router.push({
					path: '/changepassword'
				})
			},
			//修改手机号
			toChangeMobile() {
				this.$router.push({
					path: '/changemobile'
				})
			}
		},
		mounted() {

		}
	}
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";
</style>